import { render } from "./ChapterManager.vue?vue&type=template&id=7da500ed&scoped=true"
import script from "./ChapterManager.vue?vue&type=script&lang=js"
export * from "./ChapterManager.vue?vue&type=script&lang=js"

import "./ChapterManager.vue?vue&type=style&index=0&id=7da500ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da500ed"]])

export default __exports__